import { render } from "./AddTranslation.vue?vue&type=template&id=d83a22fe&scoped=true"
import script from "./AddTranslation.vue?vue&type=script&lang=js"
export * from "./AddTranslation.vue?vue&type=script&lang=js"

import "./AddTranslation.vue?vue&type=style&index=0&id=d83a22fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d83a22fe"]])

export default __exports__